"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var data_1 = require("./data");
var EXAMPLE_SRC = 'components/tree/examples/index.ts';
var TreeExample = /** @class */ (function () {
    function TreeExample() {
        var _this = this;
        this.handleNodeExpand = function (node) {
            _this.expandedMap.set(node.key, true);
        };
        this.handleNodeCollapse = function (node) {
            _this.expandedMap.delete(node.key);
        };
        this.handleClick = function (node) {
            var id = node.key;
            _this.selectedId = _this.selectedId === id ? undefined : id;
        };
    }
    TreeExample.prototype.oninit = function () {
        this.expandedMap = new Map();
    };
    TreeExample.prototype.view = function () {
        var _this = this;
        return (0, mithril_1.default)(examples_1.Example, { center: false, src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Tree, {
                class: 'cui-example-tree-component',
                nodes: data_1.data.map(function (item) { return _this.renderNode(item); })
            })
        ]);
    };
    TreeExample.prototype.renderNode = function (item) {
        var _this = this;
        var _a = item.children, children = _a === void 0 ? [] : _a, id = item.id, type = item.type;
        var hasChildren = children.length !== 0;
        var contentRight = (0, mithril_1.default)(_1.Popover, {
            hasArrow: false,
            class: _1.Classes.POPOVER_MENU,
            closeOnContentClick: true,
            content: (0, mithril_1.default)(_1.Menu, [
                (0, mithril_1.default)(_1.MenuItem, {
                    iconLeft: _1.Icons.COPY,
                    label: 'Copy'
                }),
                (0, mithril_1.default)(_1.MenuItem, {
                    iconLeft: _1.Icons.TRASH_2,
                    intent: 'negative',
                    label: 'Delete'
                })
            ]),
            position: 'bottom-end',
            trigger: (0, mithril_1.default)(_1.Icon, {
                name: _1.Icons.MORE_HORIZONTAL,
                onclick: function () { return null; }
            })
        });
        var contentLeft = (0, mithril_1.default)(_1.Icon, {
            name: type === 'Folder' ? _1.Icons.FOLDER : _1.Icons.FILE_TEXT
        });
        return (0, mithril_1.default)(_1.TreeNode, {
            contentLeft: contentLeft,
            contentRight: type === 'File' && contentRight,
            children: children.map(function (child) { return _this.renderNode(child); }),
            hasCaret: hasChildren,
            label: "".concat(type, " ").concat(id),
            key: id,
            isExpanded: this.expandedMap.has(id),
            isSelected: this.selectedId === id,
            onExpand: this.handleNodeExpand,
            onCollapse: this.handleNodeCollapse,
            onClick: this.handleClick
        });
    };
    return TreeExample;
}());
exports.TreeExample = TreeExample;
